import { Box } from "@mui/material";
import { Helmet } from 'react-helmet-async';
import {
  Banner,
  // JoinUs,
  OurDoctors,
  OurServices,
  Testimonial,
  Blog,
} from "components";

import { WhyAmrit, OurExcellence, OurFacility } from "./components";

const Home = () => {
  return (
    <Box>
      <Helmet>
       
        <meta name="description" content="Amrit Hospital | Multi-speciality Hospital | Expert Care Across
      All Specialties Leading Ophthalmology Department Affordable,
      Quality Healthcare | Chennai" />
       
      </Helmet>
      <Banner />
      <OurServices />
      <OurFacility />
      <WhyAmrit />
      <OurExcellence />
      <OurDoctors />
      {/* <JoinUs /> */}
      <Testimonial />
      <Blog />
    </Box>
  );
};

export default Home;
